<template>
  <div
    class="w-full bg-white sesssion ml-3 mt-3 border rounded-md border-grey-300 p-3 cursor-pointer transition-all duration-300"
    @click="handleViewSessionDetail(session_data)"
  >
    <p class="fs-24 fw-600 max-line-2 txt-pri title mr-18 labels">
      <span
        class="text-white fs-12"
        :class="getStatus(session_data.status).class"
      >{{ getStatus(session_data.status).text }}</span>
    </p>
    <p
      class="fw-700 fs-16 txt-primary"
    >{{ getMultilangValue(session_data.circle_schedule_language) ? getMultilangValue(session_data.circle_schedule_language).title : session_data.title }}</p>
    <p
      class="fs-16 txt-primary fw-500"
    >{{ $t(`conference.lbl_room`) }} "{{ getMultilangValue(session_data.circle_info.circle_language) ? getMultilangValue(session_data.circle_info.circle_language).name : session_data.circle_info.name }}: {{ getMultilangValue(session_data.circle_info.circle_language) ? getMultilangValue(session_data.circle_info.circle_language).location : session_data.circle_info.location }}"</p>
    <p
      class="fs-14 txt-grey"
    >{{ getMultilangValue(session_data.circle_schedule_language) ? getMultilangValue(session_data.circle_schedule_language).content : session_data.content }}</p>
    <div class="d-flex gap-3">
      <div
        v-for="speaker in session_data.circle_schedule_speakers"
        :key="speaker.id"
        class="d-flex align-items-center"
      >
        <div style="min-width: 40px">
          <span
            v-if="speaker.user_speaker.avatar"
            class="avatar avatar-sm avatar-rounded"
            :style="
              'background-image: url(' +
              getImageURL(speaker.user_speaker.avatar) +
              ')'
            "
          ></span>
          <span v-else class="avatar avatar-sm avatar-rounded bg-pri text-white">
            {{
            speaker.user_speaker.name.charAt(0) ||
            speaker.user_speaker.email.charAt(0)
            }}
          </span>
        </div>
        <div class="flex-1">
          <p
            class="fs-14 txt-primary fw-500 mb-0"
          >{{ getMultilangValue(speaker.user_speaker.speaker_multi_language) ? getMultilangValue(speaker.user_speaker.speaker_multi_language).name : speaker.user_speaker.name }}</p>
        </div>
      </div>
    </div>
    <div class="d-flex gap-4 mt-3" style="color: #98A2B3;">
      <div class="d-flex gap-2 items-center">
        <svg
          style="margin-bottom: 1px;"
          width="14"
          height="14"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.5 5.5H6.5V3.5C6.5 3.36739 6.44732 3.24021 6.35356 3.14645C6.25979 3.05268 6.13261 3 6 3C5.86739 3 5.74022 3.05268 5.64645 3.14645C5.55268 3.24021 5.5 3.36739 5.5 3.5V6C5.5 6.13261 5.55268 6.25979 5.64645 6.35355C5.74022 6.44732 5.86739 6.5 6 6.5H7.5C7.63261 6.5 7.75979 6.44732 7.85356 6.35355C7.94732 6.25979 8 6.13261 8 6C8 5.86739 7.94732 5.74021 7.85356 5.64645C7.75979 5.55268 7.63261 5.5 7.5 5.5ZM6 1C5.0111 1 4.0444 1.29324 3.22215 1.84265C2.39991 2.39206 1.75904 3.17295 1.3806 4.08658C1.00217 5.00021 0.90315 6.00555 1.09608 6.97545C1.289 7.94536 1.76521 8.83627 2.46447 9.53553C3.16373 10.2348 4.05465 10.711 5.02455 10.9039C5.99446 11.0969 6.99979 10.9978 7.91342 10.6194C8.82705 10.241 9.60794 9.6001 10.1573 8.77785C10.7068 7.95561 11 6.98891 11 6C11 5.34339 10.8707 4.69321 10.6194 4.08658C10.3681 3.47995 9.99983 2.92876 9.53554 2.46447C9.07124 2.00017 8.52005 1.63188 7.91342 1.3806C7.30679 1.12933 6.65661 1 6 1ZM6 10C5.20888 10 4.43552 9.7654 3.77772 9.32588C3.11992 8.88635 2.60723 8.26164 2.30448 7.53073C2.00173 6.79983 1.92252 5.99556 2.07686 5.21964C2.2312 4.44371 2.61216 3.73098 3.17158 3.17157C3.73099 2.61216 4.44372 2.2312 5.21964 2.07686C5.99557 1.92252 6.79983 2.00173 7.53074 2.30448C8.26164 2.60723 8.88635 3.11992 9.32588 3.77772C9.76541 4.43552 10 5.20887 10 6C10 7.06087 9.57858 8.07828 8.82843 8.82843C8.07828 9.57857 7.06087 10 6 10Z"
            fill="#98A2B3"
          />
        </svg>
        <span>{{ session_data.duration }} {{ lang === 1 ? "phút" : "minutes" }}</span>
      </div>
      <div class="d-flex gap-2 items-center">
        <svg
          style="margin-bottom: 1px;"
          width="14"
          height="14"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 9.5C6.09889 9.5 6.19556 9.47068 6.27779 9.41574C6.36001 9.36079 6.4241 9.2827 6.46194 9.19134C6.49978 9.09998 6.50969 8.99944 6.49039 8.90245C6.4711 8.80546 6.42348 8.71637 6.35355 8.64645C6.28363 8.57652 6.19454 8.5289 6.09755 8.50961C6.00055 8.49031 5.90002 8.50022 5.80866 8.53806C5.7173 8.5759 5.63921 8.63999 5.58427 8.72221C5.52932 8.80444 5.5 8.90111 5.5 9C5.5 9.13261 5.55268 9.25979 5.64645 9.35355C5.74021 9.44732 5.86739 9.5 6 9.5ZM8.5 9.5C8.59889 9.5 8.69556 9.47068 8.77779 9.41574C8.86001 9.36079 8.9241 9.2827 8.96194 9.19134C8.99978 9.09998 9.00969 8.99944 8.99039 8.90245C8.9711 8.80546 8.92348 8.71637 8.85355 8.64645C8.78363 8.57652 8.69454 8.5289 8.59755 8.50961C8.50056 8.49031 8.40002 8.50022 8.30866 8.53806C8.2173 8.5759 8.13921 8.63999 8.08426 8.72221C8.02932 8.80444 8 8.90111 8 9C8 9.13261 8.05268 9.25979 8.14645 9.35355C8.24021 9.44732 8.36739 9.5 8.5 9.5ZM8.5 7.5C8.59889 7.5 8.69556 7.47068 8.77779 7.41573C8.86001 7.36079 8.9241 7.2827 8.96194 7.19134C8.99978 7.09998 9.00969 6.99945 8.99039 6.90245C8.9711 6.80546 8.92348 6.71637 8.85355 6.64645C8.78363 6.57652 8.69454 6.5289 8.59755 6.50961C8.50056 6.49031 8.40002 6.50022 8.30866 6.53806C8.2173 6.5759 8.13921 6.63999 8.08426 6.72221C8.02932 6.80444 8 6.90111 8 7C8 7.13261 8.05268 7.25979 8.14645 7.35355C8.24021 7.44732 8.36739 7.5 8.5 7.5ZM6 7.5C6.09889 7.5 6.19556 7.47068 6.27779 7.41573C6.36001 7.36079 6.4241 7.2827 6.46194 7.19134C6.49978 7.09998 6.50969 6.99945 6.49039 6.90245C6.4711 6.80546 6.42348 6.71637 6.35355 6.64645C6.28363 6.57652 6.19454 6.5289 6.09755 6.50961C6.00055 6.49031 5.90002 6.50022 5.80866 6.53806C5.7173 6.5759 5.63921 6.63999 5.58427 6.72221C5.52932 6.80444 5.5 6.90111 5.5 7C5.5 7.13261 5.55268 7.25979 5.64645 7.35355C5.74021 7.44732 5.86739 7.5 6 7.5ZM9.5 1.5H9V1C9 0.867392 8.94732 0.740215 8.85355 0.646447C8.75979 0.552678 8.63261 0.5 8.5 0.5C8.36739 0.5 8.24021 0.552678 8.14645 0.646447C8.05268 0.740215 8 0.867392 8 1V1.5H4V1C4 0.867392 3.94732 0.740215 3.85355 0.646447C3.75979 0.552678 3.63261 0.5 3.5 0.5C3.36739 0.5 3.24021 0.552678 3.14645 0.646447C3.05268 0.740215 3 0.867392 3 1V1.5H2.5C2.10218 1.5 1.72064 1.65804 1.43934 1.93934C1.15804 2.22064 1 2.60218 1 3V10C1 10.3978 1.15804 10.7794 1.43934 11.0607C1.72064 11.342 2.10218 11.5 2.5 11.5H9.5C9.89782 11.5 10.2794 11.342 10.5607 11.0607C10.842 10.7794 11 10.3978 11 10V3C11 2.60218 10.842 2.22064 10.5607 1.93934C10.2794 1.65804 9.89782 1.5 9.5 1.5ZM10 10C10 10.1326 9.94732 10.2598 9.85355 10.3536C9.75979 10.4473 9.63261 10.5 9.5 10.5H2.5C2.36739 10.5 2.24021 10.4473 2.14645 10.3536C2.05268 10.2598 2 10.1326 2 10V5.5H10V10ZM10 4.5H2V3C2 2.86739 2.05268 2.74021 2.14645 2.64645C2.24021 2.55268 2.36739 2.5 2.5 2.5H3V3C3 3.13261 3.05268 3.25979 3.14645 3.35355C3.24021 3.44732 3.36739 3.5 3.5 3.5C3.63261 3.5 3.75979 3.44732 3.85355 3.35355C3.94732 3.25979 4 3.13261 4 3V2.5H8V3C8 3.13261 8.05268 3.25979 8.14645 3.35355C8.24021 3.44732 8.36739 3.5 8.5 3.5C8.63261 3.5 8.75979 3.44732 8.85355 3.35355C8.94732 3.25979 9 3.13261 9 3V2.5H9.5C9.63261 2.5 9.75979 2.55268 9.85355 2.64645C9.94732 2.74021 10 2.86739 10 3V4.5ZM3.5 7.5C3.59889 7.5 3.69556 7.47068 3.77779 7.41573C3.86001 7.36079 3.9241 7.2827 3.96194 7.19134C3.99978 7.09998 4.00969 6.99945 3.99039 6.90245C3.9711 6.80546 3.92348 6.71637 3.85355 6.64645C3.78363 6.57652 3.69454 6.5289 3.59755 6.50961C3.50055 6.49031 3.40002 6.50022 3.30866 6.53806C3.2173 6.5759 3.13921 6.63999 3.08427 6.72221C3.02932 6.80444 3 6.90111 3 7C3 7.13261 3.05268 7.25979 3.14645 7.35355C3.24021 7.44732 3.36739 7.5 3.5 7.5ZM3.5 9.5C3.59889 9.5 3.69556 9.47068 3.77779 9.41574C3.86001 9.36079 3.9241 9.2827 3.96194 9.19134C3.99978 9.09998 4.00969 8.99944 3.99039 8.90245C3.9711 8.80546 3.92348 8.71637 3.85355 8.64645C3.78363 8.57652 3.69454 8.5289 3.59755 8.50961C3.50055 8.49031 3.40002 8.50022 3.30866 8.53806C3.2173 8.5759 3.13921 8.63999 3.08427 8.72221C3.02932 8.80444 3 8.90111 3 9C3 9.13261 3.05268 9.25979 3.14645 9.35355C3.24021 9.44732 3.36739 9.5 3.5 9.5Z"
            fill="#98A2B3"
          />
        </svg>
        <span>{{ formatEpochTime(session_data.schedule_date, session_data.duration) }}</span>
      </div>
      <div class="d-flex gap-2 items-center">
        <svg
          style="margin-bottom: 1px;"
          width="14"
          height="14"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.99996 2.23999C8.20432 1.44434 7.12518 0.997345 5.99996 0.997345C4.87475 0.997345 3.79561 1.44434 2.99996 2.23999C2.20432 3.03564 1.75732 4.11477 1.75732 5.23999C1.75732 6.3652 2.20432 7.44434 2.99996 8.23999L5.63496 10.88C5.68145 10.9269 5.73675 10.964 5.79768 10.9894C5.85861 11.0148 5.92396 11.0279 5.98996 11.0279C6.05597 11.0279 6.12132 11.0148 6.18225 10.9894C6.24318 10.964 6.29848 10.9269 6.34496 10.88L8.99996 8.21499C9.79229 7.42265 10.2374 6.34801 10.2374 5.22749C10.2374 4.10696 9.79229 3.03232 8.99996 2.23999ZM8.28496 7.49999L5.99996 9.79499L3.71496 7.49999C3.26354 7.04814 2.9562 6.47261 2.83181 5.84613C2.70742 5.21965 2.77156 4.57036 3.01612 3.98033C3.26067 3.39029 3.67467 2.88601 4.20578 2.53122C4.73689 2.17644 5.36126 1.98708 5.99996 1.98708C6.63867 1.98708 7.26304 2.17644 7.79415 2.53122C8.32526 2.88601 8.73925 3.39029 8.98381 3.98033C9.22837 4.57036 9.29251 5.21965 9.16812 5.84613C9.04373 6.47261 8.73639 7.04814 8.28496 7.49999ZM4.49996 3.70499C4.09632 4.10987 3.86966 4.65827 3.86966 5.22999C3.86966 5.8017 4.09632 6.3501 4.49996 6.75499C4.79985 7.05538 5.18176 7.26053 5.59779 7.34469C6.01382 7.42885 6.44544 7.38828 6.8385 7.22806C7.23156 7.06785 7.56856 6.79513 7.80721 6.44411C8.04585 6.0931 8.17553 5.67942 8.17997 5.25499C8.18222 4.97159 8.12763 4.69061 8.01942 4.42868C7.91121 4.16674 7.75158 3.92916 7.54996 3.72999C7.3518 3.52728 7.1155 3.36575 6.85468 3.25472C6.59385 3.14368 6.31364 3.08532 6.03017 3.083C5.7467 3.08068 5.46556 3.13443 5.20295 3.24118C4.94034 3.34793 4.70143 3.50555 4.49996 3.70499ZM6.84496 6.04499C6.65549 6.23736 6.40507 6.35794 6.13653 6.38611C5.86799 6.41429 5.598 6.34831 5.37272 6.19945C5.14744 6.05059 4.98086 5.82811 4.90147 5.57003C4.82207 5.31195 4.83479 5.0343 4.93744 4.78456C5.0401 4.53482 5.22631 4.32849 5.46426 4.20085C5.7022 4.07321 5.97709 4.03219 6.24193 4.08479C6.50677 4.1374 6.74512 4.28036 6.91622 4.48925C7.08732 4.69814 7.18055 4.95997 7.17996 5.22999C7.17269 5.53862 7.04321 5.83175 6.81996 6.04499H6.84496Z"
            fill="#98A2B3"
          />
        </svg>
        <span>{{ getMultilangValue(session_data.circle_info.circle_language) ? getMultilangValue(session_data.circle_info.circle_language).location : session_data.circle_info.location }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { LANGUAGE_CODES_FOR_DISEASE } from '@/lang'
import appUtils from '@/utils/appUtils'

export default {
  name: 'SearchSessionItem',
  data () {
    return {}
  },
  props: ['session_data', 'valueSearch'],
  computed: {
    lang () {
      return LANGUAGE_CODES_FOR_DISEASE[this.$lang.toUpperCase()]
    }
  },
  methods: {
    getMultilangValue (data) {
      if (!data) return ''
      return data.find(item => (item.Lang || item.lang) === this.lang)
    },
    getImageURL (a) {
      if (a.includes('https')) return a
      return appUtils.getDocumentURL(a)
    },
    formatEpochTime (utcMlSeconds, duration) {
      let d = new Date(0) // The 0 there is the key, which sets the date to the epoch
      d.setUTCSeconds(utcMlSeconds / 1000)
      let endTime = utcMlSeconds / 1000 + +duration * 60
      let n = new Date(0)
      n.setUTCSeconds(endTime)
      return (
        window.moment(d).format('DD/MM/YYYY HH:mm') +
          ' - ' +
          String(n.getHours()).padStart(2, '0') +
          ':' +
          String(n.getMinutes()).padStart(2, '0') || ''
      )
    },
    getStatus (status) {
      let schedule_date = new Date(0) // The 0 there is the key, which sets the date to the epoch
      schedule_date.setUTCSeconds(this.session_data.schedule_date / 1000)
      if (schedule_date > Date.now()) {
        switch (status) {
          case 1:
            return {
              text: this.$t('conference.lbl_draft'),
              class: 'draft'
            }
          case 2:
            return {
              text: this.$t('conference.lbl_public'),
              class: 'public'
            }
          case 3:
            return {
              text: this.$t('conference.lbl_ongoing'),
              class: 'ongoing'
            }
          default:
            return {
              text: this.$t('conference.lbl_draft'),
              class: 'draft'
            }
        }
      } else {
        return {
          text: this.$t('conference.lbl_end'),
          class: 'finish'
        }
      }
    },
    handleViewSessionDetail (item) {
      if (!item?.circle_id) return
      if (this.$route.name === 'OrganizationConferenceDetail') {
        this.$emit('viewSessionDetail', item)
      } else {
        this.$router
          .push({
            name: 'WorkspaceConferenceSessionDetail',
            params: {
              id: item?.circle_id,
              sessionId: item.id
            }
          })
          .catch(() => {})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.txt-primary {
  color: #00388c;
}
.sesssion {
  min-height: 200px;

  &:hover {
    background-color: #e8f1ff !important;
  }
}
.labels {
  line-height: 21px;
  span {
    display: inline-block;
    text-wrap: nowrap;
    border-radius: 15px;
    padding: 2px 10px;
  }
}
.draft {
  background-color: rgb(0, 195, 255);
}
.public {
  background-color: #00b135;
}
.ongoing {
  background-color: #fef3f2;
  color: #f04438 !important;
}
.finish {
  background-color: #f2f4f7;
  color: #667085 !important;
}
</style>>
